import PopupComponent from '@components/std-components/Popup'
import '@styles/Icon/size-one-icons.css'

import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import Tooltip from '@material-ui/core/Tooltip'
import Icon from '@components/std-components/Icons'
import { useObserver } from 'mobx-react-lite'
import { NewSortIcon } from '../../svg'
import { EnhancedSortContent } from './EnhancedSortContent'
import MaterialUIBadge from '@material-ui/core/Badge'

export const EnhancedSortByPopup: FC<{
  sortByProps: any
  popupProps: any
}> = ({ sortByProps, popupProps }) => {
  return useObserver(function useHook() {
    const { t } = useTranslation()
    const { onClose } = popupProps
    const { isSortApplied } = sortByProps?.enhancedSortStore
    return (
      <PopupComponent
        trigger={
          <div>
            <Tooltip title={t('SA.enhancedView.sortBy', 'Sort By')}>
              <MaterialUIBadge variant='dot' invisible={!isSortApplied} color='primary'>
                <Icon imageSrc={NewSortIcon} alt={'sortBy'} />
              </MaterialUIBadge>
            </Tooltip>
          </div>
        }
        contentStyle={{
          width: '320px',
          height: '55%',
          padding: 0,
          boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.15)'
        }}
        nested={true}
        position='bottom right'
        {...popupProps}
      >
        <EnhancedSortContent {...sortByProps} onClose={onClose} />
      </PopupComponent>
    )
  })
}
